import { get } from "@/utils/request";
import { ApiResponse } from '@/types/common';

const prefix = process.env.VUE_APP_PAY_PRE_URL;
/**
 * 后端转发
 * {@link} https://event-manager.oceanengine.com/docs/8650/h5_api_docs
 */
export const sendBackEventAPI = (params: { clickId: string, eventType: string }): Promise<[unknown, ApiResponse<any>]> => {
  return get(prefix + "/advertisingapi/douyin/callback", {
    params,
  });
};
